/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upgrade_Modal_ActivateInputs */

const en_upgrade_modal_activate = /** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activate ${i?.tier} Membership`)
};

const es_upgrade_modal_activate = /** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activar Membresía ${i?.tier}`)
};

const fr_upgrade_modal_activate = /** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activer l'abonnement ${i?.tier}`)
};

const de_upgrade_modal_activate = /** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tier}-Mitgliedschaft aktivieren`)
};

const id_upgrade_modal_activate = /** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktifkan Keanggotaan ${i?.tier}`)
};

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const ja_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const zh_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const ar_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const it_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const ru_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const pt_upgrade_modal_activate = en_upgrade_modal_activate;

/** @type {(inputs: Upgrade_Modal_ActivateInputs) => LocalizedString} */
const ko_upgrade_modal_activate = en_upgrade_modal_activate;

/**
* | output |
* | --- |
* | "Activate {tier} Membership" |
*
* @param {Upgrade_Modal_ActivateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_activate = /** @type {((inputs: Upgrade_Modal_ActivateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_ActivateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_activate(inputs)
	if (locale === "es") return es_upgrade_modal_activate(inputs)
	if (locale === "fr") return fr_upgrade_modal_activate(inputs)
	if (locale === "de") return de_upgrade_modal_activate(inputs)
	if (locale === "ja") return ja_upgrade_modal_activate(inputs)
	if (locale === "zh") return zh_upgrade_modal_activate(inputs)
	if (locale === "ar") return ar_upgrade_modal_activate(inputs)
	if (locale === "id") return id_upgrade_modal_activate(inputs)
	if (locale === "it") return it_upgrade_modal_activate(inputs)
	if (locale === "ru") return ru_upgrade_modal_activate(inputs)
	if (locale === "pt") return pt_upgrade_modal_activate(inputs)
	return ko_upgrade_modal_activate(inputs)
});